import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=7942e65e&scoped=true&"
import script from "./ImageBlock.vue?vue&type=script&lang=ts&"
export * from "./ImageBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ImageBlock.vue?vue&type=style&index=0&id=7942e65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942e65e",
  null
  
)

export default component.exports